(() => {
  function initGalleryDots() {
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      const dots = gallery.querySelector('.jdm-gallery-dots');
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      const list = viewer?.querySelector('.product__media-list');
      if (!dots || !viewer || !list || dots.dataset.initialized) return;
      dots.dataset.initialized = 'true';
      const labelTemplate = dots.dataset.dotLabel;
      const getSlides = () => Array.from(list.children).filter((slide) => slide.matches('li[data-media-id]') && !slide.hidden && getComputedStyle(slide).display !== 'none');
      const mobileGallery = matchMedia('(max-width: 749.98px)');
      const sizeGallery = (mediaId) => {
        if (!mobileGallery.matches) {
          list.style.removeProperty('--jdm-gallery-height');
          return;
        }
        const slide = getSlides().find((item) => item.dataset.mediaId === mediaId);
        const media = slide?.querySelector('.product-media-container');
        const ratio = Number(media?.dataset.naturalRatio);
        if (!ratio || !slide.clientWidth) return;
        const height = `${Math.round(slide.clientWidth / ratio)}px`;
        if (list.style.getPropertyValue('--jdm-gallery-height') !== height) list.style.setProperty('--jdm-gallery-height', height);
      };
      const markActive = (mediaId) => {
        sizeGallery(mediaId);
        dots.querySelectorAll('button').forEach((button) => {
          if (button.dataset.jdmMediaId === mediaId) {
            if (button.getAttribute('aria-current') !== 'true') button.setAttribute('aria-current', 'true');
          } else if (button.hasAttribute('aria-current')) button.removeAttribute('aria-current');
        });
      };
      let sequence = '';
      const rebuild = () => {
        const slides = getSlides();
        const nextSequence = slides.map((slide) => slide.dataset.mediaId).join('|');
        if (nextSequence !== sequence) {
          const existing = new Map(Array.from(dots.querySelectorAll('button')).map((button) => [button.dataset.jdmMediaId, button]));
          const buttons = slides.map((slide, index) => {
            const button = existing.get(slide.dataset.mediaId) || document.createElement('button');
            button.type = 'button';
            button.className = 'jdm-gallery-dot';
            button.dataset.jdmMediaId = slide.dataset.mediaId;
            button.setAttribute('aria-controls', list.id);
            button.setAttribute('aria-label', labelTemplate.replace('__index__', String(index + 1)).replace('__count__', String(slides.length)));
            if (!button.firstElementChild) {
              const point = document.createElement('span');
              point.setAttribute('aria-hidden', 'true');
              button.appendChild(point);
            }
            return button;
          });
          dots.replaceChildren(...buttons);
          sequence = nextSequence;
        }
        dots.hidden = slides.length < 2;
        const active = slides.find((slide) => slide.classList.contains('is-active')) || slides[0];
        if (active) markActive(active.dataset.mediaId);
      };
      let scrollFrame;
      const syncVisibleSlide = () => {
        if (scrollFrame) return;
        scrollFrame = requestAnimationFrame(() => {
          scrollFrame = null;
          const slides = getSlides();
          const listRect = list.getBoundingClientRect();
          if (!listRect.width) return;
          const center = listRect.left + listRect.width / 2;
          const closest = slides.reduce((best, slide) => {
            const rect = slide.getBoundingClientRect();
            const distance = Math.abs((rect.left + rect.right) / 2 - center);
            return !best || distance < best.distance ? { slide, distance } : best;
          }, null);
          if (closest) markActive(closest.slide.dataset.mediaId);
        });
      };
      dots.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-jdm-media-id]');
        if (!button) return;
        const slide = getSlides().find((item) => item.dataset.mediaId === button.dataset.jdmMediaId);
        if (!slide) return;
        if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(slide.dataset.mediaId);
        else list.scrollTo({ left: slide.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        markActive(slide.dataset.mediaId);
      });
      viewer.addEventListener('slideChanged', (event) => {
        const slide = event.detail?.currentElement;
        if (slide) markActive(slide.dataset.mediaId);
      });
      list.addEventListener('scroll', syncVisibleSlide, { passive: true });
      let rebuildFrame;
      new MutationObserver((records) => {
        const relevant = records.some((record) =>
          record.type === 'childList' ? record.target === list : record.target.parentElement === list && record.target.matches('li[data-media-id]')
        );
        if (!relevant || rebuildFrame) return;
        rebuildFrame = requestAnimationFrame(() => {
          rebuildFrame = null;
          rebuild();
          syncVisibleSlide();
        });
      }).observe(list, { childList: true, attributes: true, subtree: true, attributeFilter: ['class', 'hidden'] });
      let observedWidth;
      new ResizeObserver(([entry]) => {
        const width = entry.contentRect.width;
        if (width === observedWidth) return;
        observedWidth = width;
        syncVisibleSlide();
      }).observe(list);
      mobileGallery.addEventListener('change', () => {
        if (!mobileGallery.matches) list.style.removeProperty('--jdm-gallery-height');
        syncVisibleSlide();
      });
      rebuild();
      gallery.classList.add('jdm-gallery-ready');
    });
  }
  function initBundleDisclosure() {
    const config = document.getElementById('sticky-prod-header');
    const root = document.getElementById('frequently-bought-together-app-block');
    if (!config || !root || root.dataset.jdmDisclosure) return;
    root.dataset.jdmDisclosure = 'true';
    let expanded = false;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'jdm-bundle-toggle';
    const refresh = () => {
      const panels = Array.from(root.querySelectorAll('.cbb-frequently-bought-selector-list'));
      if (!panels.length) return;
      const ids = panels.map((panel, index) => {
        if (!panel.id) panel.id = `jdm-bundle-panel-${index}`;
        if (panel.hidden !== !expanded) panel.hidden = !expanded;
        if (panel.inert !== !expanded) panel.inert = !expanded;
        if (panel.getAttribute('aria-hidden') !== String(!expanded)) panel.setAttribute('aria-hidden', String(!expanded));
        return panel.id;
      });
      if (root.classList.contains('jdm-bundle-collapsed') !== !expanded) root.classList.toggle('jdm-bundle-collapsed', !expanded);
      if (button.getAttribute('aria-expanded') !== String(expanded)) button.setAttribute('aria-expanded', String(expanded));
      if (button.getAttribute('aria-controls') !== ids.join(' ')) button.setAttribute('aria-controls', ids.join(' '));
      const label = expanded ? config.dataset.bundleCollapse : config.dataset.bundleExpand;
      if (button.textContent !== label) button.textContent = label;
      if (!root.contains(button)) {
        const pictures = root.querySelector('.cbb-frequently-bought-products');
        if (pictures) pictures.insertAdjacentElement('afterend', button);
        else root.prepend(button);
      }
    };
    button.addEventListener('click', () => { expanded = !expanded; refresh(); });
    let refreshFrame;
    new MutationObserver((records) => {
      if (records.every((record) => record.target === button || button.contains(record.target))) return;
      if (refreshFrame) return;
      refreshFrame = requestAnimationFrame(() => {
        refreshFrame = null;
        refresh();
      });
    }).observe(root, { childList: true, subtree: true });
    refresh();
  }
  function choiceRowSizes(count) {
    const rows = [];
    while (count > 0) {
      const size = count <= 3 ? count : count === 4 ? 2 : 3;
      rows.push(size);
      count -= size;
    }
    return rows;
  }
  function initOptionRows() {
    document.querySelectorAll('.product:has(.jdm-product-identity)').forEach((root) => {
      if (root.dataset.jdmOptionRows) return;
      root.dataset.jdmOptionRows = 'true';
      const update = () => {
        root.querySelectorAll('.gpo-app').forEach((app) => {
          let precedingVisibleField = false;
          app.querySelectorAll('.gpo-form__group.gpo-element').forEach((field) => {
            const visible = !field.hidden && field.getClientRects().length && getComputedStyle(field).display !== 'none' && getComputedStyle(field).visibility !== 'hidden' && field.querySelector('.gpo-label:not(.hidden)');
            const follows = Boolean(visible && precedingVisibleField);
            if (follows && !field.hasAttribute('data-jdm-option-following')) field.setAttribute('data-jdm-option-following', '');
            else if (!follows && field.hasAttribute('data-jdm-option-following')) field.removeAttribute('data-jdm-option-following');
            if (visible) precedingVisibleField = true;
          });
        });
        root.querySelectorAll('.gpo-app .gpo-ov-wrapper.horizontal').forEach((group) => {
          const items = Array.from(group.children).filter((item) => item.matches('.gpo-ov-item'));
          if (!items.length || items.some((item) => !item.matches('.gpo-swatches.buttons'))) return;
          const visible = items.filter((item) => !item.hidden && item.getClientRects().length && getComputedStyle(item).display !== 'none' && getComputedStyle(item).visibility !== 'hidden');
          const columns = choiceRowSizes(visible.length).flatMap((size) => Array(size).fill(String(size)));
          const assignment = new Map(visible.map((item, index) => [item, columns[index]]));
          items.forEach((item) => {
            const value = assignment.get(item);
            if (value && item.dataset.jdmChoiceColumns !== value) item.dataset.jdmChoiceColumns = value;
            else if (!value && item.hasAttribute('data-jdm-choice-columns')) item.removeAttribute('data-jdm-choice-columns');
          });
          if (visible.length && !group.hasAttribute('data-jdm-choice-rows')) group.setAttribute('data-jdm-choice-rows', '');
          else if (!visible.length && group.hasAttribute('data-jdm-choice-rows')) group.removeAttribute('data-jdm-choice-rows');
        });
      };
      let pending;
      const schedule = () => {
        if (pending) return;
        pending = requestAnimationFrame(() => { pending = null; update(); });
      };
      // Observe app visibility/rerender inputs, never our own data attributes.
      new MutationObserver((records) => {
        if (records.some((record) => record.type === 'childList' || record.target.closest('.gpo-app'))) schedule();
      }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'data-clo-display'] });
      root.addEventListener('change', schedule);
      window.addEventListener('resize', schedule);
      update();
    });
  }
  function initGalleryShare() {
    document.querySelectorAll('.product:has(.jdm-product-identity)').forEach((root) => {
      const sku = root.querySelector('product-info [id^="Sku-"]');
      const share = root.querySelector('.social-share');
      if (!sku || !share) return;
      let skuRow = sku.closest('.jdm-sku-share-row');
      if (!skuRow) {
        skuRow = document.createElement('div');
        skuRow.className = 'jdm-sku-share-row';
        sku.parentNode.insertBefore(skuRow, sku);
        skuRow.appendChild(sku);
      }
      let shareRow = share.closest('.jdm-gallery-share');
      if (!shareRow) {
        shareRow = document.createElement('div');
        shareRow.className = 'jdm-gallery-share';
        const caption = share.previousElementSibling;
        if (caption?.classList.contains('caption')) shareRow.appendChild(caption);
        shareRow.appendChild(share);
      }
      if (shareRow.parentNode !== skuRow) skuRow.appendChild(shareRow);
    });
  }
  function hasMissingRequiredOption(group) {
    const fields = Array.from(group.querySelectorAll('[presence]:not([disabled])'));
    return fields.some((field) => {
      if (field.type === 'radio' || field.type === 'checkbox') {
        const key = field.dataset.name || field.name;
        return !fields.some((other) => (other.dataset.name || other.name) === key && other.checked);
      }
      if (field.type === 'file') {
        const savedFile = Array.from(group.closest('.product').querySelectorAll('.gpo-hidden-inputs [data-field-name]')).find((item) => item.dataset.fieldName === field.dataset.fieldName && !item.disabled && item.value);
        return !field.files?.length && !field.hasAttribute('data-has-file') && !savedFile;
      }
      if (field.tagName === 'SELECT' && field.multiple) return !Array.from(field.selectedOptions).some((option) => !option.disabled && option.value);
      return 'value' in field && !String(field.value).trim();
    });
  }
  function initOptionFeedback() {
    document.querySelectorAll('.product:has(.jdm-product-identity)').forEach((root) => {
      if (root.dataset.jdmOptionFeedback) return;
      root.dataset.jdmOptionFeedback = 'true';
      let deadline = 0;
      let pending;
      let expiry;
      let trigger;
      let firstError;
      let freshNativeErrors = false;
      let dialog;
      const visibleErrors = () => Array.from(root.querySelectorAll('.gpo-app .gpo-form__group.has-error')).filter((group) =>
        group.getClientRects().length && getComputedStyle(group).visibility !== 'hidden' && group.querySelector('.messages .help-block.error')?.textContent.trim()
      );
      const focusError = () => {
        const errors = visibleErrors();
        const group = errors.includes(firstError) ? firstError : errors[0];
        if (!group) { if (trigger?.isConnected) trigger.focus({ preventScroll: true }); return; }
        group.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        const field = Array.from(group.querySelectorAll('input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),button:not([disabled])')).find((item) => getComputedStyle(item).display !== 'none');
        field?.focus({ preventScroll: true });
        if (!field || document.activeElement !== field) {
          group.setAttribute('tabindex', '-1');
          group.focus({ preventScroll: true });
        }
      };
      const present = (message) => {
        if (dialog?.open) return;
        if (!dialog) {
          dialog = document.createElement('dialog');
          dialog.className = 'jdm-option-error-dialog';
          dialog.setAttribute('role', 'alertdialog');
          dialog.setAttribute('aria-modal', 'true');
          const text = document.createElement('p');
          text.id = `jdm-option-error-${document.querySelectorAll('.jdm-option-error-dialog').length}`;
          dialog.setAttribute('aria-labelledby', text.id);
          const close = document.createElement('button');
          close.type = 'button';
          close.textContent = 'Close';
          close.addEventListener('click', () => dialog.close());
          dialog.append(text, close);
          dialog.addEventListener('close', focusError);
          document.body.appendChild(dialog);
        }
        dialog.querySelector('p').textContent = message;
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
          dialog.querySelector('button').focus();
        } else { window.alert(message); focusError(); }
      };
      const check = () => {
        if (!deadline || performance.now() > deadline || !freshNativeErrors) return;
        const nativeDecision = window.GPOConfigs?.diagAtc?.()?.last?.decision;
        if (nativeDecision && nativeDecision !== 'errors') return;
        const errors = visibleErrors();
        if (!errors.length) return;
        deadline = 0;
        clearTimeout(expiry);
        firstError = errors[0];
        // Native validation alone blocks the cart and determines error groups.
        present(errors.some(hasMissingRequiredOption) ? 'Please fill in all required fields.' : 'Please check the highlighted option fields.');
      };
      const schedule = () => {
        if (!deadline || pending) return;
        pending = requestAnimationFrame(() => { pending = null; check(); });
      };
      const isCartControl = (target) => {
        const button = target.closest('button,input[type="submit"]');
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return null;
        if (button.id === 'sticky-atc-bar-btn') return button;
        if (!root.contains(button) || button.closest('#frequently-bought-together-app-block')) return null;
        return button.matches('[name="add"],.product-form__submit') && button.form?.getAttribute('action')?.includes('/cart/add') ? button : null;
      };
      const arm = (target) => {
        if (!root.isConnected || !root.querySelector('.gpo-app')) return;
        trigger = target;
        freshNativeErrors = false;
        deadline = performance.now() + 2000;
        clearTimeout(expiry);
        expiry = setTimeout(() => { deadline = 0; }, 2000);
      };
      const disarm = () => { deadline = 0; freshNativeErrors = false; clearTimeout(expiry); };
      window.addEventListener('pointercancel', disarm, true);
      window.addEventListener('pointerdown', disarm, true);
      window.addEventListener('input', (event) => { if (root.contains(event.target) && event.target.closest('.gpo-app')) disarm(); }, true);
      // Arm after pointer-induced blur/change, immediately before native click.
      // Globo may stop its own click/submit at window capture; we never replay it.
      window.addEventListener('pointerup', (event) => {
        const button = event.button === 0 ? isCartControl(event.target) : null;
        if (button) arm(button); else disarm();
      }, true);
      window.addEventListener('keydown', (event) => {
        if (root.contains(event.target) && event.target.closest('.gpo-app')) disarm();
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const button = isCartControl(event.target);
        if (button) arm(button);
        else if (event.key === 'Enter' && root.contains(event.target) && event.target.matches('input:not([type="radio"]):not([type="checkbox"])') && event.target.form?.getAttribute('action')?.includes('/cart/add') && !event.target.closest('#frequently-bought-together-app-block')) arm(event.target);
      }, true);
      window.addEventListener('click', (event) => { const button = isCartControl(event.target); if (button) { arm(button); schedule(); } }, true);
      window.addEventListener('submit', (event) => {
        if (root.contains(event.target) && event.target.getAttribute('action')?.includes('/cart/add') && !event.target.closest('#frequently-bought-together-app-block')) { arm(event.submitter || event.target); schedule(); }
      }, true);
      new MutationObserver((records) => {
        if (!deadline) return;
        if (records.some((record) => record.type === 'childList' && record.target.closest?.('.gpo-app .messages'))) freshNativeErrors = true;
        if (freshNativeErrors) schedule();
      }).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    });
  }
  function init() {
    initGalleryShare();
    initOptionFeedback();
    initOptionRows();
    initGalleryDots();
    initBundleDisclosure();
    const bar = document.getElementById('sticky-prod-header');
    if (!bar || bar.dataset.initialized) return;
    bar.dataset.initialized = 'true';
    const sectionId = bar.dataset.sectionId;
    const identity = document.getElementById(`ProductIdentity-${sectionId}`);
    if (!identity) return;
    document.body.appendChild(bar);
    const updateVisibility = () => {
      const rect = identity.getBoundingClientRect();
      bar.classList.toggle('sph--visible', rect.height > 0 && rect.bottom <= 0);
    };
    let frame;
    window.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => { updateVisibility(); frame = null; });
    }, { passive: true });
    window.addEventListener('resize', updateVisibility);
    const sku = document.getElementById(`Sku-${sectionId}`);
    if (sku) {
      const updateSku = () => {
        bar.querySelector('[data-sticky-sku]').textContent = sku.textContent.trim();
        bar.querySelector('.sph-sku').hidden = !sku.textContent.trim();
      };
      new MutationObserver(updateSku).observe(sku, { childList: true, characterData: true, subtree: true });
      updateSku();
    }
    updateVisibility();
  }
  const copyTimers = new WeakMap();
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-copy-sku]');
    if (!button) return;
    const source = button.querySelector('[data-sticky-sku]') || button;
    const value = source.textContent.trim();
    const config = document.getElementById('sticky-prod-header');
    const status = document.getElementById('jdm-sku-copy-status');
    if (!value || !config) return;
    let message;
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(value);
      message = config.dataset.skuCopied;
    } catch {
      const range = document.createRange();
      range.selectNodeContents(source);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      message = config.dataset.skuCopyFallback;
    }
    button.dataset.copyFeedback = message;
    if (status) status.textContent = `${message} ${value}`;
    clearTimeout(copyTimers.get(button));
    copyTimers.set(button, setTimeout(() => { delete button.dataset.copyFeedback; }, 3000));
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.jdm-review-link');
    if (!link) return;
    const reviews = document.getElementById('wc_review_section');
    if (!reviews) return;
    event.preventDefault();
    reviews.setAttribute('tabindex', '-1');
    reviews.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    reviews.focus({ preventScroll: true });
    history.replaceState(null, '', '#wc_review_section');
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();


